module.exports = __webpack_public_path__ + "static/media/exit.ae351592.svg";